import { Directive, TemplateRef } from '@angular/core'

/**
 * Marks a `<ng-template>` as the per-row expanded-content slot for
 * `<app-detail-table>`. Receives the row as `$implicit`.
 *
 * Usage:
 *
 *     <app-detail-table [config]="cfg" [rows]="rows">
 *       <ng-template detailTableExpanded let-row>
 *         <ul>
 *           <li *ngFor="let e of entriesByStation.get(row.station_id)">
 *             {{ e.user_name }} — {{ e.duration_minutes }}m
 *           </li>
 *         </ul>
 *       </ng-template>
 *     </app-detail-table>
 */
@Directive({
    selector: '[detailTableExpanded]',
    standalone: true
})
export class DetailTableExpandedDirective<T = unknown> {
    constructor(public template: TemplateRef<{ $implicit: T }>) {}

    static ngTemplateContextGuard<T>(
        _dir: DetailTableExpandedDirective<T>,
        ctx: unknown
    ): ctx is { $implicit: T } {
        return true
    }
}
